import * as React from "react";
import { cn } from "@repo/utils/cn";

export interface RichtextListProps {
  columnsAmount?: "one" | "two";
  children: React.ReactNode;
}

export const RichtextList = React.forwardRef<HTMLUListElement, RichtextListProps>(
  ({ columnsAmount = "one", children }, ref) => {
    return (
      <>
        <style>{`
          .richtext-list-columns-two {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr;
            column-gap: 2rem;
          }

          @media (min-width: 768px) {
            .richtext-list-columns-two {
              grid-template-columns: 1fr 1fr;
            }
          }
        `}</style>
        <ul
          ref={ref}
          className={cn(
            "uipm:w-full",
            columnsAmount === "two" && "richtext-list-columns-two"
          )}
        >
          {children}
        </ul>
      </>
    );
  }
);

RichtextList.displayName = "RichtextList";
